// Content for the ATNA product page hero.
export type Bi = { fr: string; en: string }

export const ATNA_LOGO = 'https://cdn.magicpatterns.com/uploads/d6cqpG2SGUofNqC1hEedXv/Logo_ATNA_(5).png'

export const atnaHeroCopy = {
  eyebrow: { fr: 'ATNA — Intelligence agentique', en: 'ATNA — Agentic intelligence' },
  // Alternating indigo / navy lines
  headline: [
    { text: { fr: 'Plus de capacité', en: 'More capacity' }, accent: true },
    { text: { fr: 'pour vos équipes.', en: 'for your teams.' }, accent: false },
    { text: { fr: 'De meilleurs services', en: 'Better services' }, accent: true },
    { text: { fr: 'pour vos usagers.', en: 'for your users.' }, accent: false },
  ] as { text: Bi; accent: boolean }[],
  body: {
    fr: 'ATNA comprend les demandes de vos usagers, utilise le contexte autorisé, vérifie l’information et orchestre les prochaines actions — pour vous aider à traiter davantage, plus rapidement et avec plus de confiance.',
    en: 'ATNA understands your users’ requests, uses authorized context, verifies information and orchestrates the next actions — helping you handle more, faster and with greater confidence.',
  },
  secondary: { fr: 'Demander une démo', en: 'Request a demo' },
}

export type EntryKey = 'web' | 'app' | 'portal' | 'email' | 'phone' | 'llm'
export const atnaUsers = {
  title: { fr: 'Vos usagers', en: 'Your users' },
  sub: { fr: 'Des points d’entrée multiples.', en: 'Multiple entry points.' },
  items: [
    { key: 'web', label: { fr: 'Site Web', en: 'Website' } },
    { key: 'app', label: { fr: 'App mobile', en: 'Mobile app' } },
    { key: 'portal', label: { fr: 'Portail Mon espace', en: 'My Space portal' } },
    { key: 'email', label: { fr: 'Courriel', en: 'Email' } },
    { key: 'phone', label: { fr: 'Téléphone', en: 'Phone' } },
    { key: 'llm', label: { fr: 'IA générative / recherche IA', en: 'LLM / AI search' } },
  ] as { key: EntryKey; label: Bi }[],
}

export type CoreKey = 'understand' | 'context' | 'verify' | 'recommend' | 'act'
export const atnaCore = {
  tagline: [{ fr: 'Intelligence', en: 'Agentic' }, { fr: 'agentique', en: 'intelligence' }] as Bi[],
  items: [
    { key: 'understand', label: { fr: 'Comprend', en: 'Understands' } },
    { key: 'context', label: { fr: 'Contextualise', en: 'Contextualizes' } },
    { key: 'verify', label: { fr: 'Vérifie', en: 'Verifies' } },
    { key: 'recommend', label: { fr: 'Recommande', en: 'Recommends' } },
    { key: 'act', label: { fr: 'Orchestre et agit', en: 'Orchestrates and acts' } },
  ] as { key: CoreKey; label: Bi }[],
}

export type OpsKey = 'manual' | 'priorities' | 'actions' | 'services'
export const atnaOps = {
  title: { fr: 'Vos équipes et vos opérations', en: 'Your teams & operations' },
  sub: { fr: 'Des services qui avancent.', en: 'Services that move forward.' },
  items: [
    { key: 'manual', label: [{ fr: 'Moins de', en: 'Less' }, { fr: 'traitement manuel', en: 'manual processing' }] },
    { key: 'priorities', label: [{ fr: 'Priorités identifiées', en: 'Priorities identified' }] },
    { key: 'actions', label: [{ fr: 'Actions préparées', en: 'Actions prepared' }] },
    { key: 'services', label: [{ fr: 'Services orchestrés', en: 'Services orchestrated' }, { fr: 'dans vos systèmes', en: 'in your systems' }] },
  ] as { key: OpsKey; label: Bi[] }[],
}

export type BenefitKey = 'capacity' | 'manual' | 'speed' | 'quality'
export const atnaBenefits: { key: BenefitKey; label: Bi[] }[] = [
  { key: 'capacity', label: [{ fr: 'Capacité', en: 'Increased' }, { fr: 'opérationnelle accrue', en: 'operational capacity' }] },
  { key: 'manual', label: [{ fr: 'Moins de', en: 'Fewer' }, { fr: 'tâches manuelles', en: 'manual tasks' }] },
  { key: 'speed', label: [{ fr: 'Plus grande', en: 'Faster' }, { fr: 'rapidité de service', en: 'service delivery' }] },
  { key: 'quality', label: [{ fr: 'Une qualité de service', en: 'Higher, more consistent' }, { fr: 'supérieure et constante', en: 'service quality' }] },
]
